import { _firestore } from '../../firebase';

export async function getJsonDataFromFile(
  key,
  url,
  isPopularDisabled = false,
) {
  const bucketName = 'store-menu-hashes-prod';
  const commonCloudUrlPrefix = `https://storage.googleapis.com/${bucketName}`;

  try {
    // Extract and encode parts of the URL
    const [urlPrefix, ...urlSuffixParts] = url.split('/');
    const urlSuffix = encodeURIComponent(urlSuffixParts.join('/'));
    const fullUrl = `${commonCloudUrlPrefix}/${urlPrefix}/${urlSuffix}`;

    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ${key}. Status: ${response.status}`);
    }

    const responseData = await response.json();

    return resolveJsonDataFromFile(responseData?.[key], key);
  } catch (err) {
    console.log('Error reading json file', err);
    return null;
  }
}

export function resolveJsonDataFromFile(data, key = null) {
  if (key === 'storeReviewStats') {
    return data[0] || null;
  }
  return data || null;
}

export function getUpdatedStoreMenuUrls(storeId) {
  return new Promise((resolve, _reject) => {
    _firestore
      .collection('StoreMenuHashes')
      .doc(storeId)
      .get()
      .then((querySnapshot) => {
        const data = querySnapshot.data();
        if (!data || Object.keys(data).length === 0) return resolve({});
        resolve(data);
      });
  });
}
